(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5907],{

/***/ 78657:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration",
      function () {
        return __webpack_require__(75082);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ ReCAPTCHA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50259);


function ReCAPTCHA(param) {
    var onVerify = param.onVerify, _showNotice = param.showNotice, showNotice = _showNotice === void 0 ? true : _showNotice, _refreshReCaptcha = param.refreshReCaptcha, refreshReCaptcha = _refreshReCaptcha === void 0 ? false : _refreshReCaptcha;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showNotice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                children: [
                    "Este site \xe9 protegido pelo reCAPTCHA e o Google. Consulte as",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://policies.google.com/privacy",
                        children: "Pol\xedticas de privacidade"
                    }),
                    " e os",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://policies.google.com/terms",
                        children: "Termos de Uso"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_1__/* .GoogleReCaptcha */ .mP, {
                onVerify: onVerify,
                refreshReCaptcha: refreshReCaptcha
            })
        ]
    });
}


/***/ }),

/***/ 75082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ LoginPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(37946);
// EXTERNAL MODULE: ./components/ReCAPTCHA.tsx
var ReCAPTCHA = __webpack_require__(78558);
;// CONCATENATED MODULE: ./components/ModalRegistration.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #5cc9aa;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #ffffff;\n  padding: 2rem;\n  border-radius: 13px;\n  display: flex;\n  flex-direction: column;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90%;\n  overflow-y: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border-bottom: solid 1px #ccc;\n  padding-bottom: 1rem;\n\n  & > span:first-child {\n    margin-right: 1rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem 0;\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 30px;\n  height: 30px;\n  background-color: ",
        ";\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  cursor: pointer;\n  z-index: 1;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background-color: #ccc;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "%;\n  height: 100%;\n  background-color: #5cc9aa;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11pt;\n  padding: 1rem 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 1rem 0;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #5cc9aa;\n  color: #ffffff;\n  padding: 12px 25px;\n  font-family: 'Nunito';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  outline: none;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: gray;\n\n  &:hover {\n    background: darkgray;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #5cc9aa;\n\n  &:hover {\n    background: #4da88f;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}



var ModalRegistration = function(param) {
    var show = param.show, handleClose = param.handleClose, handleSubmit = param.handleSubmit;
    var ref = (0,react.useState)(1), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var nextStep = function() {
        return setStep(function(prevStep) {
            return prevStep < 4 ? prevStep + 1 : prevStep;
        });
    };
    var prevStep = function() {
        return setStep(function(prevStep) {
            return prevStep > 1 ? prevStep - 1 : prevStep;
        });
    };
    var goToStep = function(stepNumber) {
        return setStep(stepNumber);
    };
    var handleFinalSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        return [
                            4,
                            handleSubmit(e)
                        ];
                    case 1:
                        _state.sent();
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFinalSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOverlay, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "Cria\xe7\xe3o de Conta"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepIndicator, {
                        children: [
                            [
                                1,
                                2,
                                3,
                                4
                            ].map(function(stepNumber) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepItem, {
                                    active: stepNumber <= step,
                                    onClick: function() {
                                        return goToStep(stepNumber);
                                    },
                                    children: stepNumber
                                }, stepNumber);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressLine, {
                                    step: step
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Conforme Termos de Uso, declaro possuir uma conta corrente ou conta poupan\xe7a, com TITULAR DE MESMO CPF cadastrado no site Meu Nascimento, em um dos BANCOS ACEITOS para realiza\xe7\xe3o de transfer\xeancia dos presentes convertidos em dinheiro."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {
                                                onClick: handleClose,
                                                children: "Cancelar"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                                                onClick: nextStep,
                                                children: "Pr\xf3ximo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "A lista de bancos aceitos s\xe3o:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Banco do Brasil"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Santander"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Inter"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Caixa Econ\xf4mica Federal"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Stone"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Banco BTG"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Bradesco"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Nubank"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "C6"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Ita\xfa"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Safra"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {
                                                onClick: prevStep,
                                                children: "Voltar"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                                                onClick: nextStep,
                                                children: "Pr\xf3ximo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Em virtude da seguran\xe7a exigida pela operadora Pagar.me (Banco Stone), N\xc3O \xc9 POSS\xcdVEL ALTERAR o CPF ap\xf3s confirma\xe7\xe3o do cadastro."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {
                                                onClick: prevStep,
                                                children: "Voltar"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                                                onClick: nextStep,
                                                children: "Pr\xf3ximo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "N\xe3o ser\xe3o solicitadas pelo Nossa Vaquinha, ou pela Pagar.me, em hip\xf3tese alguma, quaisquer tipos de senhas pessoais ao usu\xe1rio do Nossa Vaquinha."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "O \xfanico canal oficial para comunica\xe7\xe3o com o cliente \xe9 atrav\xe9s do e-mail: contato@nossavaquinha.com.br"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {
                                                onClick: prevStep,
                                                children: "Voltar"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                                                onClick: handleFinalSubmit,
                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingIcon, {}) : "De Acordo e Finalizar Cadastro"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var LoadingIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-0"
})(_templateObject1(), rotate);
var ModalOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-1"
})(_templateObject2());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-2"
})(_templateObject3());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-3"
})(_templateObject4());
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-92d27be0-4"
})(_templateObject5());
var StepIndicator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-5"
})(_templateObject6());
var StepItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-6"
})(_templateObject7(), function(param) {
    var active = param.active;
    return active ? "#5cc9aa" : "#ccc";
});
var ProgressBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-7"
})(_templateObject8());
var ProgressLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-8"
})(_templateObject9(), function(param) {
    var step = param.step;
    return step / 4 * 100;
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-9"
})(_templateObject10());
var Step = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-10"
})(_templateObject11());
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d27be0-11"
})(_templateObject12());
var NextButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-92d27be0-12"
})(_templateObject13());
var PrevButton = (0,styled_components_browser_esm/* default */.ZP)(NextButton).withConfig({
    componentId: "sc-92d27be0-13"
})(_templateObject14());
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(NextButton).withConfig({
    componentId: "sc-92d27be0-14"
})(_templateObject15());
/* harmony default export */ var components_ModalRegistration = (ModalRegistration);

// EXTERNAL MODULE: ./contexts/AuthContext.tsx + 1 modules
var AuthContext = __webpack_require__(52681);
// EXTERNAL MODULE: ./contexts/ReCAPTCHAContext.tsx
var ReCAPTCHAContext = __webpack_require__(84114);
;// CONCATENATED MODULE: ./utils/emailValidation.ts
function validateEmail(email) {
    return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(email);
}

;// CONCATENATED MODULE: ./utils/validFieldCard.ts
function formattedCPF(num) {
    return num.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}
function formattedCard(num) {
    return num.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1 $2 $3 $4");
}
function addPhoneNumberPattern(phoneNumber) {
    return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
}
function dataBirthDayPattern(data) {
    return data.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
}
function isEmail(email) {
    var value = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return value.test(String(email).toLowerCase());
}

;// CONCATENATED MODULE: ./pages/registration.tsx




function registration_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    registration_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function registration_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  background: #fbf9ed;\n\n  justify-content: space-between;\n\n  @media (max-width: 766px) {\n    flex-direction: column;\n  }\n"
    ]);
    registration_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function registration_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 100vh;\n  width: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  border-radius: 2px 25px 25px 2px;\n\n  img {\n    max-width: 101%;\n    object-fit: cover;\n  }\n\n  @media (max-width: 1000px) {\n    display: none;\n  }\n"
    ]);
    registration_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function registration_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n\n  margin-right: 7rem;\n\n  @media (max-width: 766px) {\n    height: 100vh;\n    width: 100vw;\n  }\n"
    ]);
    registration_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function registration_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n\n  @media (max-width: 390px) {\n    width: 74vw;\n  }\n\n  @media (max-width: 766px) {\n    width: 74vw;\n  }\n"
    ]);
    registration_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function registration_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-bottom: 10px;\n\n  img {\n    display: block;\n  }\n\n  @media (max-width: 766px) {\n    img {\n      margin-top: 1rem;\n      width: 80%;\n    }\n  }\n"
    ]);
    registration_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function registration_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  input {\n    width: 100%;\n    font-size: 1.5rem;\n    background: #fbf9ed;\n    padding: 1rem;\n    border: ",
        ";\n    border-radius: 10px;\n  }\n\n  input::placeholder {\n    font-size: 15px;\n    color: #222222;\n    font-weight: 500;\n  }\n\n  input:hover {\n    border: solid 2px #797bb0;\n    color: #0076a0;\n  }\n\n  input:focus {\n    font-size: 14px;\n    border: solid 2px #174f68;\n    color: #222222;\n  }\n\n  input:focus,\n  select:focus {\n    box-shadow: 0.3px 0.3px 0.3px;\n    outline: 0;\n  }\n\n  img {\n    position: absolute;\n    margin: 10px 20px;\n  }\n\n  a {\n    font-size: 15px;\n    color: #174f68;\n    float: right;\n    transition: all 0.5s;\n  }\n\n  a {\n    margin: 2.4rem;\n  }\n\n  @media (max-width: 766px) {\n    a {\n      font-size: 13px;\n    }\n  }\n"
    ]);
    registration_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function registration_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 10px;\n  width: 100%;\n  border: none;\n  font-weight: 500;\n  padding: 1rem 0;\n  background: #174f68;\n  font-size: 15px;\n  color: #fff;\n  cursor: pointer;\n  text-transform: uppercase;\n  transition: all 0.5s;\n\n  :hover {\n    opacity: 0.6;\n  }\n"
    ]);
    registration_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function registration_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 1rem;\n\n  > a {\n    font-size: 20px;\n    transition: all 0.5s;\n    color: #174f68;\n    font-weight: 500;\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  :hover {\n    opacity: 0.5;\n  }\n\n  @media (max-width: 766px) {\n    a {\n      font-size: 13px;\n    }\n  }\n"
    ]);
    registration_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function registration_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5rem;\n  display: flex;\n\n  input {\n    width: 1.5rem;\n  }\n\n  a {\n    text-decoration: none;\n    margin-left: 5px;\n    color: #f09192;\n  }\n"
    ]);
    registration_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function registration_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f5f5f5;\n  border-radius: 10px;\n  border: solid 1px #5cc9aa;\n  position: relative;\n  z-index: 9999;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  .lineAlert {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    span {\n      font-size: 14px;\n      color: #ddd;\n      margin-left: 5px;\n    }\n\n    .error {\n      color: #174f68;\n    }\n\n    .sucess {\n      color: #5cc9aa;\n    }\n  }\n\n  @media (max-width: 766px) {\n    width: 100%;\n  }\n"
    ]);
    registration_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function registration_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: #174f68;\n  max-width: 300px;\n"
    ]);
    registration_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function registration_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: #174f68;\n  font-weight: 500;\n  text-decoration: none;\n  margin-top: 4px;\n\n  label {\n    margin-right: 10px;\n  }\n\n  select {\n    width: 16%;\n    padding: 2px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n    color: #333;\n    cursor: pointer;\n    outline: none;\n    transition: border-color 0.3s;\n  }\n\n  @media (max-width: 766px) {\n    select {\n      width: 23%;\n    }\n  }\n"
    ]);
    registration_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}












var __N_SSP = true;
function LoginPage() {
    var handlePaste = function handlePaste(event) {
        event.preventDefault(); // desativa copiar e colar
    };
    var ref = (0,react.useState)(""), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(false), nameError = ref1[0], setNameError = ref1[1];
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), phone = ref3[0], setPhone = ref3[1];
    var ref4 = (0,react.useState)(false), phoneError = ref4[0], setPhoneError = ref4[1];
    var ref5 = (0,react.useState)(""), cpf = ref5[0], setCpf = ref5[1];
    var ref6 = (0,react.useState)(false), errorCPFCNPJ = ref6[0], setErrorCPFCNPJ = ref6[1];
    var ref7 = (0,react.useState)(""), confirmEmail = ref7[0], setConfirmEmail = ref7[1];
    var ref8 = (0,react.useState)(""), confirmEmailError = ref8[0], setConfirmEmailError = ref8[1];
    var ref9 = (0,react.useState)(false), emailError = ref9[0], setEmailError = ref9[1];
    var ref10 = (0,react.useState)(""), password = ref10[0], setPassword = ref10[1];
    var ref11 = (0,react.useState)(""), confirmPassword = ref11[0], setConfirmPassword = ref11[1];
    var ref12 = (0,react.useState)(""), errorConfirmPassword = ref12[0], setErrorConfirmPassword = ref12[1];
    var ref13 = (0,react.useState)(false), passwordError = ref13[0], setPasswordError = ref13[1];
    var ref14 = (0,react.useState)(false), isCheckTermsConditions = ref14[0], setIsCheckTermsConditions = ref14[1];
    var ref15 = (0,react.useState)(""), messageErrorPassword = ref15[0], setMessageErrorPassword = ref15[1];
    var ref16 = (0,ReCAPTCHAContext/* useReCAPTCHA */.V)(), handleVerifyRecaptcha = ref16.handleVerifyRecaptcha, recaptcha = ref16.recaptcha, refreshRecaptcha = ref16.refreshRecaptcha, setRefreshRecaptcha = ref16.setRefreshRecaptcha;
    var ref17 = (0,react.useState)("password"), typeInputPassword = ref17[0], setTypeInputPassword = ref17[1];
    var ref18 = (0,react.useState)("password"), typeInputConfirmPassword = ref18[0], setTypeInputConfirmPassword = ref18[1];
    var ref19 = (0,react.useState)(false), isMother = ref19[0], setIsMother = ref19[1];
    var ref20 = (0,react.useState)("CPF"), typePerson = ref20[0], setTypePerson = ref20[1];
    var ref21 = (0,_sliced_to_array/* default */.Z)(name.split(" "), 2), firstName = ref21[0], lastName = ref21[1];
    var ref22 = (0,react.useState)(false), showModal = ref22[0], setShowModal = ref22[1];
    var handleChangeDocumentType = function(event) {
        var inputValue = event.target.value;
        if (inputValue) {
            setErrorCPFCNPJ(false);
        }
        setCpf(regexNumero(inputValue));
    // if (inputValue.length <= 11) {
    //   setCpf(inputValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
    // } else {
    //   setCpf(inputValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"));
    //   setTypePerson("CNPJ")
    // }
    };
    var regexLetters = function(e) {
        return e.target.value.replace(/[^a-zA-Zà-ùÀ-Ù ]/g, "");
    };
    var regexNumero = function(string) {
        return string.replace(/[^0-9]/g, "");
    };
    var ref23 = (0,AuthContext/* useAuth */.a)(), signUp = ref23.signUp, loading = ref23.loading;
    function handleSubmit(e) {
        return _handleSubmit.apply(this, arguments);
    }
    function _handleSubmit() {
        _handleSubmit = (0,_async_to_generator/* default */.Z)(function(e) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (name.length < 3) {
                            react_toastify_esm/* toast.error */.Am.error("Digite um nome v\xe1lido!");
                            setNameError(true);
                        }
                        if (!firstName || !lastName) {
                            react_toastify_esm/* toast.error */.Am.error("Digite o nome completo!");
                            setNameError(true);
                        }
                        if (password.length <= 7) {
                            setPasswordError(true);
                            react_toastify_esm/* toast.error */.Am.error("A senha precisa ter pelo menos 8 caracteres!");
                        }
                        if (!validateEmail(email)) {
                            setEmailError(true);
                            react_toastify_esm/* toast.error */.Am.error("Digite um email v\xe1lido!");
                        }
                        if (email !== confirmEmail) {
                            react_toastify_esm/* toast.error */.Am.error("Os emails n\xe3o coincidem!");
                            return [
                                2
                            ];
                        }
                        if (phone.length !== 10 && phone.length !== 11) {
                            setPhoneError(true);
                            react_toastify_esm/* toast.error */.Am.error("Digite um telefone v\xe1lido!");
                            return [
                                2
                            ];
                        }
                        if (!cpf.length) {
                            react_toastify_esm/* toast.error */.Am.error("\xc9 necess\xe1rio informar o cpf.");
                            setErrorCPFCNPJ(true);
                            return [
                                2
                            ];
                        }
                        if (password !== confirmPassword) {
                            react_toastify_esm/* toast.error */.Am.error("As senhas devem ser iguais.");
                            return [
                                2
                            ];
                        }
                        if (!isCheckTermsConditions) {
                            react_toastify_esm/* toast.error */.Am.error("\xc9 necess\xe1rio aceitar os termos e condi\xe7\xf5es");
                            return [
                                2
                            ];
                        }
                        if (messageErrorPassword.length) {
                            react_toastify_esm/* toast.error */.Am.error(messageErrorPassword);
                            return [
                                2
                            ];
                        }
                        if (name.length < 3 || !validateEmail(email) || password.length < 8) return [
                            2
                        ];
                        data = {
                            name: name,
                            email: email,
                            password: password,
                            recaptcha: recaptcha,
                            cpf: cpf,
                            phone: phone
                        };
                        return [
                            4,
                            signUp(data)
                        ];
                    case 1:
                        _state.sent();
                        setRefreshRecaptcha(Date.now());
                        setShowModal(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReCAPTCHAContext/* ReCAPTCHAProvider */.g, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        newestOnTop: false,
                        closeOnClick: true,
                        rtl: false,
                        pauseOnFocusLoss: true,
                        draggable: true,
                        pauseOnHover: true,
                        theme: "light",
                        style: {
                            zIndex: 9999999
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(registration_Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Left, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/login-left.png",
                                    alt: "background"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Right, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                                    onSubmit: function(e) {
                                        e.preventDefault();
                                        setShowModal(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(registration_Header, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/Logo.svg",
                                                alt: "logo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                                            error: nameError,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                name: "nome",
                                                placeholder: "Nome completo",
                                                value: name,
                                                onChange: function(e) {
                                                    setName(regexLetters(e));
                                                    if (name.length > 3) setNameError(false);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                                            error: emailError,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "email",
                                                placeholder: "E-mail",
                                                onChange: function(e) {
                                                    setEmail(e.target.value);
                                                    if (validateEmail(email)) setEmailError(false);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                            error: emailError,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "email",
                                                    onPaste: handlePaste,
                                                    placeholder: "Confirme seu e-mail",
                                                    onChange: function(e) {
                                                        setConfirmEmail(e.target.value);
                                                        if (!e.target.value.length) setConfirmEmailError("Preenchimento obrigatorio!");
                                                        else if (e.target.value !== email) setConfirmEmailError("Os e-mails n\xe3o coincidem!");
                                                        else setConfirmEmailError("");
                                                    }
                                                }),
                                                confirmEmailError.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage, {
                                                    children: confirmEmailError
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                                            error: phoneError,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "tel",
                                                placeholder: "Telefone",
                                                value: phone,
                                                maxLength: 11,
                                                onChange: function(e) {
                                                    setPhone(regexNumero(e.target.value));
                                                    if (phone.length === 10 || phone.length === 11) setPhoneError(false);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                                            error: errorCPFCNPJ,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: typePerson,
                                                placeholder: "CPF",
                                                maxLength: typePerson === "CPF" ? 11 : 14,
                                                minLength: typePerson === "CPF" ? 11 : 14,
                                                value: formattedCPF(cpf),
                                                onChange: handleChangeDocumentType
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                            error: passwordError,
                                            style: {
                                                position: "relative"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: typeInputPassword,
                                                    placeholder: "Senha",
                                                    onChange: function(e) {
                                                        var validatePassword = /(?=.*[}{%&$@ç!#*,.^?~=+\-/*\-+.|])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[0-9]).{8,}/gm;
                                                        setPassword(e.target.value);
                                                        if (e.target.value.length && !validatePassword.test(e.target.value)) setMessageErrorPassword("A senha deve possuir pelo menos 8 digitos, letras ma\xedusculas, min\xfasculas e caracteres especiais.");
                                                        else setMessageErrorPassword("");
                                                        if (password.length > 8) setPasswordError(false);
                                                    }
                                                }),
                                                typeInputPassword === "text" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineEyeInvisible */.I0d, {
                                                    style: {
                                                        position: "absolute",
                                                        right: "15px",
                                                        top: "10px",
                                                        cursor: "pointer"
                                                    },
                                                    size: 25,
                                                    onClick: function() {
                                                        return setTypeInputPassword("password");
                                                    }
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineEye */.Zju, {
                                                    size: 25,
                                                    style: {
                                                        position: "absolute",
                                                        right: "15px",
                                                        top: "10px",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return setTypeInputPassword("text");
                                                    }
                                                }),
                                                password.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerMessageErrorPassword, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "lineAlert",
                                                            children: [
                                                                password.length < 8 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                                                    size: 14,
                                                                    fill: "#174F68"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCheck */.bzc, {
                                                                    size: 14,
                                                                    fill: "#5cc9aa"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: password.length >= 8 ? "sucess" : "error",
                                                                    children: "8 caracteres contendo"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "lineAlert",
                                                            children: [
                                                                /(?=.*[A-Z])/.test(password) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCheck */.bzc, {
                                                                    size: 14,
                                                                    fill: "#5cc9aa"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                                                    size: 14,
                                                                    fill: "#174F68"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: /(?=.*[A-Z])/.test(password) ? "sucess" : "error",
                                                                    children: "1 Caractere mai\xfasculo"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "lineAlert",
                                                            children: [
                                                                /(?=.*[a-z])/.test(password) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCheck */.bzc, {
                                                                    size: 14,
                                                                    fill: "#5cc9aa"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                                                    size: 14,
                                                                    fill: "#174F68"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: /(?=.*[a-z])/.test(password) ? "sucess" : "error",
                                                                    children: "1 Caractere min\xfasculo"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "lineAlert",
                                                            children: [
                                                                /(?=.*\d)/.test(password) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCheck */.bzc, {
                                                                    size: 14,
                                                                    fill: "#5cc9aa"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                                                    size: 14,
                                                                    fill: "#174F68"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: /(?=.*\d)/.test(password) ? "sucess" : "error",
                                                                    children: "1 Caractere num\xe9rico"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "lineAlert",
                                                            children: [
                                                                /[^a-zA-Z 0-9]+/g.test(password) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCheck */.bzc, {
                                                                    size: 14,
                                                                    fill: "#5cc9aa"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                                                    size: 14,
                                                                    fill: "#174F68"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: /[^a-zA-Z 0-9]+/g.test(password) ? "sucess" : "error",
                                                                    children: "1 Caractere especial (s\xe3o aceitos: ?!@#$%^)"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                            error: passwordError,
                                            style: {
                                                position: "relative"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    onPaste: handlePaste,
                                                    type: typeInputConfirmPassword,
                                                    placeholder: "Confirme sua senha",
                                                    onChange: function(e) {
                                                        setConfirmPassword(e.target.value);
                                                        if (!e.target.value.length) setErrorConfirmPassword("Preenchimento obrigatorio!");
                                                        else if (e.target.value !== password) setErrorConfirmPassword("As senhas n\xe3o coincidem!");
                                                        else setErrorConfirmPassword("");
                                                    }
                                                }),
                                                typeInputConfirmPassword === "text" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineEyeInvisible */.I0d, {
                                                    style: {
                                                        position: "absolute",
                                                        right: "15px",
                                                        top: "10px",
                                                        cursor: "pointer"
                                                    },
                                                    size: 25,
                                                    onClick: function() {
                                                        return setTypeInputConfirmPassword("password");
                                                    }
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineEye */.Zju, {
                                                    size: 25,
                                                    style: {
                                                        position: "absolute",
                                                        right: "15px",
                                                        top: "10px",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return setTypeInputConfirmPassword("text");
                                                    }
                                                }),
                                                errorConfirmPassword.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage, {
                                                    children: errorConfirmPassword
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: "\xc9 m\xe3e?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    value: isMother ? "true" : "false",
                                                    onChange: function(e) {
                                                        console.log("Selected value:", e.target.value);
                                                        console.log("Parsed value:", e.target.value === "true");
                                                        setIsMother(e.target.value === "true");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "true",
                                                            children: "Sim"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "false",
                                                            children: "N\xe3o"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checkbox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    name: "",
                                                    id: "",
                                                    onClick: function() {
                                                        return setIsCheckTermsConditions(!isCheckTermsConditions);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/termos-e-condicoes",
                                                    children: "Aceito os termos e condi\xe7\xf5es"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCAPTCHA/* ReCAPTCHA */.b, {
                                            onVerify: handleVerifyRecaptcha,
                                            refreshReCaptcha: refreshRecaptcha
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                            type: "submit",
                                            children: loading ? "Carregando" : "Cadastrar"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cadastrese, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/login",
                                                children: "J\xe1 tem uma conta ? Clique aqui"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalRegistration, {
                show: showModal,
                handleClose: function() {
                    return setShowModal(false);
                },
                handleSubmit: handleSubmit
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-0"
})(registration_templateObject());
var registration_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-1"
})(registration_templateObject1());
var Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-2"
})(registration_templateObject2());
var Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-3"
})(registration_templateObject3());
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-6cfa668b-4"
})(registration_templateObject4());
var registration_Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-5"
})(registration_templateObject5());
var Group = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-6"
})(registration_templateObject6(), function(param) {
    var error = param.error;
    return error ? "2px solid #174F68" : "2px solid #174F68";
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-6cfa668b-7"
})(registration_templateObject7());
var Cadastrese = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-8"
})(registration_templateObject8());
var Checkbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-9"
})(registration_templateObject9());
var ContainerMessageErrorPassword = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-10"
})(registration_templateObject10());
var AlertMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6cfa668b-11"
})(registration_templateObject11());
var Select = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfa668b-12"
})(registration_templateObject12());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,4949,9774,2888,179], function() { return __webpack_exec__(78657); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);